
export default {
  name: "sdksPop",
  props: ['list'],
  data() {
    return {
      activeNum: 0
    }
  },
  methods: {
    changeSdk(index) {
      this.activeNum = index
    },
    goToPage(link) {
      this.$parent.menuHide = true;
      if (!location.pathname.includes(link)) {
        this.$router.push({path: link});
      }
      setTimeout(() => {
        this.$parent.menuHide = false;
      }, 100)
    }
  }
}
